import React from "react";
import { Link } from "react-router-dom";
import "../../styles/generals/header.css";
import logo from "../../images/logo.png";

function Header() {
  return (
    // <header>
      <div className="header">
        <div className="logo">
          <div>
            <Link to="/">
              <img src={logo} className="logo" alt="logo" />
            </Link>
          </div>
        </div>
        <p className="name">WELCOME TO EXCLSERV CRM SOFTWARE</p>
      </div>
    // </header>
  );
}

export default Header;
